import { Col } from 'antd';
import styled from 'styled-components';

const Sider = styled(Col)`
    @media (min-width: 1164px) {
        width: 316px;
    }
    @media (max-width: 1164px) {
        width: 33%;
    }
    @media (max-width: 992px) {
        width: 100%;
    }
`;

export default Sider;
